import React, { FunctionComponent } from 'react';

import { Rating, Stack, Typography } from '@mui/material';
import { WINDOW_V } from '../../constant/constants';

interface Props {
  device: number;
  zagolovok: string;
  title: string;
  rating: number;
  text: string;
  windowState: number;
}

export const LendingDivItemTextOtziv: FunctionComponent<Props> = ({
  device,
  zagolovok,
  title,
  rating,
  text,
  windowState,
}) => {
  const arrayDevice = [
    'Отзыв с AppStore',
    'Отзыв с Google Play',
    'Отзыв с App Gallery',
  ];
  const arrayDeviceColor = ['#3478F6', '#3B8562', '#BC2B34'];
  return (
    <Stack
      width="264px"
      height={windowState === WINDOW_V ? '255px' : '320px'}
      padding="20px"
      sx={{
        background: '#00000066',
        borderRadius: '20px',
      }}
      alignItems="flex-start"
      spacing={1}
    >
      {false && (
        <Typography
          fontWeight={400}
          fontFamily="Roboto"
          lineHeight="100%"
          fontSize={windowState === WINDOW_V ? '12px' : '14px'}
          letterSpacing="0.3px"
          textAlign="left"
          color="#FFFFFF80"
          component="text"
        >
          {zagolovok}
        </Typography>
      )}
      <Typography
        fontWeight={700}
        fontFamily="Roboto"
        lineHeight="100%"
        fontSize={windowState === WINDOW_V ? '18px' : '24px'}
        letterSpacing="0.3px"
        textAlign="left"
        color="#FFFFFF"
        component="text"
      >
        {title}
      </Typography>
      <Stack
        width="264px"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Rating name="simple-controlled" value={rating} readOnly />
        {false && (
          <Typography
            fontWeight={700}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize={windowState === WINDOW_V ? '12px' : '14px'}
            letterSpacing="0.3px"
            textAlign="left"
            color={arrayDeviceColor[device]}
            component="text"
          >
            {arrayDevice[device]}
          </Typography>
        )}
      </Stack>

      <Typography
        fontWeight={400}
        fontFamily="Roboto"
        lineHeight={windowState === WINDOW_V ? '20px' : '24px'}
        fontSize="14px"
        letterSpacing="0.3px"
        textAlign="left"
        color="#FFFFFF"
        component="text"
      >
        {text}
      </Typography>
    </Stack>
  );
};
